import track from "react-tracking";
import { catchFunction } from "./shared/lib/utils";
import { USER_TRACKING } from "./shared/lib/apiEndpointsResolver";

export default function withTracking(RootComponent) {
  const AppWithTracking = (props) => <RootComponent {...props} />;

  const getToken = () => {
    const jwt = localStorage.getItem("jwt");
    if (jwt) {
      return JSON.parse(atob(jwt)).accessToken;
    } else {
      return null;
    }
  };

  const getUser = () => {
    const user = localStorage.getItem("user");
    if (user) {
      return JSON.parse(atob(user));
    } else {
      return null;
    }
  };

  return track(
    { applicationName: "AdQuiver Control Centre" },
    {
      dispatch: (data = {}) => {
        const url = `${process.env.REACT_APP_BASE_URL}${USER_TRACKING}`;
        const user = getUser();

        const options = {
          method: "POST",
          headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...data,
            username: user.username,
            fullname: user.fullname,
            timestamp: new Date(),
          }),
        };

        fetch(url, options)
          .then((_) => {})
          .catch(catchFunction);
      },
    },
  )(AppWithTracking);
}
